var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ar-skeleton',{staticClass:"ar-typography-skeleton",style:({
    height: _vm.textSectionFontSize,
  }),attrs:{"level":_vm.level,"color":_vm.color}})}
var staticRenderFns = []

export { render, staticRenderFns }